<template>
    <el-table
            size="mini"
            :data="table"
            empty-text="No errors or warnings"
            stripe>
        <el-table-column
                label="Severity"
                prop="severity"
                width="100">
            <template slot-scope="scope">
                <span :class="scope.row.severity === 'Error' ? 'error-cell' : 'warning-cell'">
                    {{ scope.row.severity }}
                </span>
            </template>
        </el-table-column>
        <el-table-column
                label="Name"
                prop="name"
                width="160">
        </el-table-column>
        <el-table-column
                label="Description"
                prop="description"
                min-width="310">
        </el-table-column>
    </el-table>
</template>
<script>
  export default {
    name: 'LogTable',
    props: {
      table: {
        type: Array,
        default: () => ([]),
      },
    }
  }
</script>
<style scoped>
    .error-cell {
        color: red;
        font-weight: bold;
    }
    .warning-cell {
        color: darkorange;
        font-weight: bold;
    }
</style>
